export const AUTH_SUCCESS = "[AUTH_SUCCESS]"
export const AUTH_FAIL = "[AUTH_FAIL]"
export const REGISTER_SUCCESS = "[REGISTER_SUCCESS]"
export const SIGNOUT_SUCCESS = "[SIGNOUT_SUCCESS]"
export const DELETE_SUCCESS = "[DELETE_SUCCESS]"
export const FETCH_SUCCESS = "[FETCH_SUCCESS]"
export const EDIT = "[EDIT_SUCCESS]"
export const INIT_STATE = "[INIT_STATE]"
 